import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="px-5 py-8" aria-labelledby="testimonios-title" data-id="element-193" data-mp="3kr5uq9dydbmc">
      <h2 id="testimonios-title" className="text-center font-display text-[22px] text-[#16302a]" data-id="element-194" data-mp="3fym86mxaf65e">
        Profesionales que ya lo aplican
      </h2>

      <ul className="mt-5 space-y-3" data-id="element-195" data-mp="3ayqat6j3icyt">
        {testimonials.map(t => <li key={t.name} className="rounded-2xl border border-[#c9d6cd] bg-white/85 p-4 backdrop-blur-sm" data-id="element-196" data-mp="370al2uvmqqhp">
            <div className="flex items-center justify-between" data-id="element-197" data-mp="321za2gtlm9xw">
              <QuoteIcon className="h-4 w-4 text-[#6f8f7c]" aria-hidden="true" data-id="element-198" data-mp="2x1kyiossghv4" />
              <div className="flex" aria-hidden="true" data-id="element-199" data-mp="2s2i6q61tk853">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-[#e0a11a] text-[#e0a11a]" data-id="element-200" data-mp="v8dlxn4k8ecx" />)}
              </div>
            </div>
            <p className="mt-2 text-[13.5px] leading-relaxed text-[#3d4f47]" data-id="element-201" data-mp="q891jm0j6zhf">“{t.text}”</p>
            <p className="mt-3 text-[13px] font-bold text-[#16302a]" data-id="element-202" data-mp="h4n6gjawodem">{t.name}</p>
            <p className="text-[11.5px] text-[#6b7b73]" data-id="element-203" data-mp="m6m89oqzz29g">{t.role}</p>
          </li>)}
      </ul>
    </section>;
}